"use client";

import { getRichTextRenderFunction } from "../../../utils/renderRichText";
import { NotFoundComponent } from "../../not-found-component";

import type { ContentInfoPage } from "../../content";

const renderRichText = getRichTextRenderFunction(4, { topMargin: false });

type Props = {
  infoPage: ContentInfoPage | null;
};

export function PageComponent(props: Props) {
  return props.infoPage ? (
    <>{renderRichText(props.infoPage.content)}</>
  ) : (
    <NotFoundComponent />
  );
}
